import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Quote } from '../../../model/quote/quote.model';
import { QuoteService } from '../../quote.service';
import { NgbModal,ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-quote-sof',
  templateUrl: './quote-sof.component.html',
  styleUrls: ['../../quote.component.css'],
})
export class QuoteSofComponent implements OnInit {
  @Input() quote: Quote;
  statementOfFacts;


  constructor(private quoteService: QuoteService, private modalService: NgbModal) { }

  ngOnChanges(changes: SimpleChanges) {
    if(this.quote.quote_versions.length > 0 && this.quote.quote_versions[0].statement_of_facts.length > 0) {
      this.quote.quote_versions[0].statement_of_facts.forEach((res, index) => {
        if(res.response == 0) {
          res.response = null;
        }
      });
    }
 
  }

  ngOnInit(): void {
    // Get All Questions
    this.quoteService.getStatementOfFacts(environment.EQUINE_ID)
      .subscribe(
        (response: any) => {
          if (response.success) {
            this.statementOfFacts = response.result.statement_of_fact;

            if (this.quote.quote_versions[0].statement_of_facts.length <= 1) {
              response.result.statement_of_fact.forEach((res, index) => {
                this.quote.quote_versions[0].statement_of_facts.push({
                  id: '',
                  quote_id: '',
                  question_id: res.id,
                  response: null,
                  response_bool: false,
                  response_text: '',
                  display_order: res.display_order
                });

              });
            } 
          }
        },
        (error) => {
          console.log(error);
        }
      );
  }

  /*
  * HELP TEXT POPUP
  */
 helptext = '';
 helpTextPopup(content, text) {
   const modalRef = this.modalService.open(content, { centered: true });
   this.helptext = text;
 }


}
